// Cloudflare Images Configuration
export const CLOUDFLARE_CONFIG = {
  // Account ID from API URL
  ACCOUNT_ID: 'bfb1a679ca6faf7c85a4350b05feb469',
  
  // Header Profile Image ID
  HEADER_IMAGE_ID: '1b0c6841-2a9f-45dd-a3a2-e2a3e60f6600',
  
  // Banner Image ID (US Layout header banner)
  // TODO: Replace with actual Cloudflare Image ID when available
  BANNER_IMAGE_ID: '9fdc1148-5ac5-48d3-2a3a-6ce149481300', // Using same ID for now, update when banner image is uploaded
  
  // Payment Provider Logos (PNG format with transparent background)
  STRIPE_LOGO_ID: '9df325db-b5ab-4af3-6b6f-7488c5ae3800',
  COINBASE_LOGO_ID: '9df325db-b5ab-4af3-6b6f-7488c5ae3800',
  
  // Cloudflare Account Hash (Delivery Hash)
  // This is the hash used for imagedelivery.net URLs
  ACCOUNT_HASH: 'N5r9mtOgBIolYeX8w64oqg',
  
  // Cloudflare Image Delivery URLs
  // Note: For production, use imagedelivery.net with account hash
  getImageUrl: (imageId: string, variant: string = 'public'): string => {
    // Check if we have environment variable for account hash (takes priority)
    const envAccountHash = import.meta.env.VITE_CLOUDFLARE_ACCOUNT_HASH;
    
    // Use environment variable if set, otherwise use the known account hash
    const accountHash = envAccountHash || CLOUDFLARE_CONFIG.ACCOUNT_HASH;
    
    // Always use proper image delivery URL
    const imageUrl = `https://imagedelivery.net/${accountHash}/${imageId}/${variant}`;
    
    // Development: Show helpful messages if using default hash
    if (import.meta.env.DEV && !envAccountHash) {
    }
    
    return imageUrl;
  },
  
  // Predefined image variants
  VARIANTS: {
    public: 'public',
    thumbnail: 'thumbnail', 
    avatar: 'avatar',
    small: 'small',
    medium: 'medium',
    large: 'large'
  }
} as const;

// Header profile image URL
export const HEADER_PROFILE_IMAGE_URL = CLOUDFLARE_CONFIG.getImageUrl(
  CLOUDFLARE_CONFIG.HEADER_IMAGE_ID,
  'public'
);

// Banner image URL (for LATAM/International Layout header banner)
export const BANNER_IMAGE_URL = CLOUDFLARE_CONFIG.getImageUrl(
  CLOUDFLARE_CONFIG.BANNER_IMAGE_ID,
  'public' // Use public variant for banner
);

// Payment provider logo URLs
export const STRIPE_LOGO_URL = CLOUDFLARE_CONFIG.getImageUrl(
  CLOUDFLARE_CONFIG.STRIPE_LOGO_ID,
  'public'
);

export const COINBASE_LOGO_URL = CLOUDFLARE_CONFIG.getImageUrl(
  CLOUDFLARE_CONFIG.COINBASE_LOGO_ID,
  'public'
);